// extracted by mini-css-extract-plugin
export default {"iconTextWrapper":"iconText_iconTextWrapper__hEYPU","left":"iconText_left__BUiCN","right":"iconText_right__BSq0f","icon":"iconText_icon__79oWV","text":"iconText_text__vwaFx"};